import { defineMessages } from "react-intl"
import { INVENTORY_RULE_KEY, LIMIT_RULE_KEY, NULL_RULE_KEY } from "../../state/price-list/ruleStrategyKeys"

const priceListMessages = defineMessages({
    [NULL_RULE_KEY]: {
        id: "price_list.edit_validation_rules.none_key",
        defaultMessage: "None",
    },
    [INVENTORY_RULE_KEY]: {
        id: "price_list.edit_validation_rules.inventory_key",
        defaultMessage: "Inventory",
    },
    [LIMIT_RULE_KEY]: {
        id: "price_list.edit_validation_rules.order_limit_key",
        defaultMessage: "Order Limit",
    },
    "customer-type-all": {
        id: "price_list.edit_customer_type_all",
        defaultMessage: "All"
    },
})

export default priceListMessages


// WEBPACK FOOTER //
// ./src/price-list/helpers/priceListMessages.ts